import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { CustomerAccountDetailsComponent } from './customer-account.component'
import { ChangeCustAccountModule } from '../change-cust-account/change-cust-account.module'
import {
  CmsConfig,
  ConfigModule,
  I18nModule,
  provideDefaultConfig,
} from '@spartacus/core'
import { SpinnerModule } from '@spartacus/storefront'
import { MatTooltipModule } from '@angular/material/tooltip'
import { environment } from '../../../../environments/environment'
@NgModule({
  declarations: [CustomerAccountDetailsComponent],
  imports: [
    CommonModule,
    ChangeCustAccountModule,
    SpinnerModule,
    MatTooltipModule,
    I18nModule,
    ConfigModule.withConfig({
      i18n: {
        backend: {
          loadPath:
            environment.deployPath + 'assets/i18n-assets/{{lng}}/{{ns}}.json',
          // loadPath: '/_ui/responsive/common/vs-spartacus/assets/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: {
          userData: ['userData'],
        },
      },
    }),
  ],
  exports: [CustomerAccountDetailsComponent],
  providers: [
    provideDefaultConfig({
      cmsComponents: {
        VSCustomerAccountComponent: {
          component: CustomerAccountDetailsComponent,
        },
      },
    } as CmsConfig),
  ],
})
export class CustomerAccountModule {}
